import { useState } from "react";
import { ApiConnector } from "../../common/ApiConnector";
import { App } from "antd";
import { isString } from "lodash";

const useMain = () => {
    const [formOpened, setFormOpened] = useState(false);
    const [items, setItems] = useState([]);
    const { modal } = App.useApp();
    const [rubro, setRubro] = useState('todos');
    const [loading, setLoading] = useState({
        items: false,
        form: false
    });
    const defaultItem = {
        id: 0,
        rubro: '',
        nombre: '',
        marca_antigua: '',
        marca_nueva: '',

        shop: '',
        facebook: '',
        instagram: '',
        tiktok: '',
        whatsapp: '',

        captcha: true
    }
    const [item, setItem] = useState(defaultItem)

    const showForm = () => {
        setFormOpened(true);
    }

    const hideForm = () => {
        setFormOpened(false);

        window.document.forms.form1.reset();
    }

    const saveItem = async (formdata) => {
        let formData = new FormData();
        formData.append('nombre', formdata.nombre);
        formData.append('rubro', formdata.rubro);
        formData.append('marca_antigua', formdata.marca_antigua);
        formData.append('marca_nueva', formdata.marca_nueva);

        formData.append('shop', formdata.shop);
        formData.append('facebook', formdata.facebook);
        formData.append('instagram', formdata.instagram);
        formData.append('tiktok', formdata.tiktok);
        formData.append('whatsapp', formdata.whatsapp);

        let success = false;

        try {
            setLoading(prev => ({ ...prev, form: true }));
            if(formdata.id > 0) {
                formData.append('_method', 'PUT');
                await ApiConnector.post(`/api/marca/${formdata.id}`, formData);
            } else {
                await ApiConnector.post('/api/marca', formData);
            }
            success = true;
        } catch (error) {
            success = false;
        }
        finally {
            setLoading(prev => ({ ...prev, form: false }));
        }
        return success;
    }

    const sendForm = async (formdata) => {
        if(!formdata.captcha) {
            modal.error({
                content: 'Complete el captcha!'
            });
            return;
        }

        let success = await saveItem(formdata);
        if (success) {
            modal.success({
                content: 'El item fue guardado!'
            });
            hideForm();
            fillItems(1, rubro);
        }
    }

    const fillItems = async (page = 1, rubro = 'todos') => {
        try {
            setLoading(prev => ({ ...prev, items: true }));
            let res = await ApiConnector.get(`/api/marca`, {
                params: {
                    page: page,
                    rubro: rubro
                }
            });
            setItems(res.data);

        } catch { }
        finally {
            setLoading(prev => ({ ...prev, items: false }));
        }
    }

    const deleteItem = async (id) => {
        modal.confirm({
            content: '¿Eliminar item?',
            onOk: async () => {
                await ApiConnector.delete(`/api/marca/${id}`);
                fillItems(1, rubro);
            }
        });
    }

    const setEditItem = (item) => {
        setItem({...item, captcha: false});
        showForm();
    }

    const deleteMarcaAntigua = () => {
        setItem(prev => ({ ...prev, marca_antigua: null }));
    }

    const deleteMarcaNueva = () => {
        setItem(prev => ({ ...prev, marca_nueva: null }));
    }

    return {
        form: {
            opened: formOpened,
            show: showForm,
            hide: hideForm,
            send: sendForm,
            defaultItem: defaultItem,
            editItem: {
                set: setItem,
                item: item
            },
            setEditItem: setEditItem,
        },
        items,
        fillItems,
        setRubro,
        loading,
        deleteItem,
        deleteMarcaAntigua,
        deleteMarcaNueva,
    }

}

export default useMain;
